import {settings} from 'constants/url';
import {useGetToken} from 'components/hooks';
import axios from 'axios';
import {useEffect, useState} from 'react';

export function useLoadParameter() {
  const token = useGetToken();

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!token) return;

    const load = async () => {
      try {
        const response = await axios.get(settings, {
          headers: {Authorization: `Bearer ${token}`},
        });
        setData(response.data);
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  return {data, loading, error};
}
